import { render, staticRenderFns } from "./SbShareButtons.vue?vue&type=template&id=09b83601"
import script from "./SbShareButtons.vue?vue&type=script&lang=js"
export * from "./SbShareButtons.vue?vue&type=script&lang=js"
import style0 from "./SbShareButtons.vue?vue&type=style&index=0&id=09b83601&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports